import React from "react";

const BarChartSkeleton = () => {
  return (
    <div className="w-full h-[280px] animate-pulse flex flex-col justify-between py-4">
      {/* Top bars */}
      <div className="flex justify-around items-end h-full px-4">
        {/* Simulated bars */}
        {[60, 90, 40, 70].map((h, i) => (
          <div
            key={i}
            className="bg-gray-200 rounded-t"
            style={{
              width: "40px",
              height: `${h}%`,
            }}
          />
        ))}
      </div>

      {/* Bottom labels */}
      <div className="flex justify-around mt-4 px-4">
        {[1, 2, 3, 4].map((_, i) => (
          <div key={i} className="w-10 h-3 bg-gray-200 rounded"></div>
        ))}
      </div>
    </div>
  );
};

export default BarChartSkeleton;
